import moment from 'moment';

export default function dateHandler (date: string, dataOnly: boolean = false) {
  //TODO handle get date from user current timezone and convert to utc
  const dateObj = new Date(date);
  const utcDate = new Date(dateObj.getTime() + dateObj.getTimezoneOffset() * 60000);
  if(dataOnly) return moment(utcDate).format('Do MMM YYYY');
  return moment(utcDate).format('Do MMM YYYY HH:mma');
}  